import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "d-flex justify-center",
  style: {"font-size":"x-small"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_AccountableAccountBalanceDetailOpenPoints = _resolveComponent("AccountableAccountBalanceDetailOpenPoints")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_hover, null, {
      default: _withCtx(({ isHovering, props }) => [
        _createVNode(_component_v_card, _mergeProps(props, {
          elevation: isHovering ? 4 : 0,
          class: 
                    _ctx.$vuetify.display.mobile
                        ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                        : 'default_card dashboard_card d-flex flex-column ma-0'
                ,
          style: _ctx.$vuetify.display.mobile ? 'height: 100%' : 'height: 250px'
        }), {
          default: _withCtx(() => [
            (!_ctx.vueGraph)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "title ma-0 pa-2 pb-0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Title), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "title ma-0 pb-0 d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.subtitle), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "px-4"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.vueGraph && !_ctx.vueDetailed)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              "no-gutters": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: _ctx.$vuetify.display.mdAndDown ? '12' : '7',
                                  class: "d-flex flex-column justify-center align-center"
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.$vuetify.display.mobile)
                                      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.solde, undefined)), 1))
                                      : (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.solde, undefined)), 1)),
                                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.diagnostic), 1)
                                  ]),
                                  _: 1
                                }, 8, ["cols"]),
                                _createVNode(_component_v_col, {
                                  class: "d-flex flex-column justify-end align-center",
                                  cols: _ctx.$vuetify.display.mdAndDown ? '12' : '5'
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "4",
                                          class: "d-flex"
                                        }, {
                                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode(" Banque ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "d-flex font-weight-bold justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.bankAmount, undefined)), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "4",
                                          class: "d-flex"
                                        }, {
                                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode(" Factures ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "d-flex font-weight-bold justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.documentAmount, undefined)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["cols"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "mt-auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "pa-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_prev, {
                                  class: "mx-1",
                                  onClick: _ctx.previous
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                              default: _withCtx(() => [
                                (isHovering && _ctx.indexlistOpenPoints != 0)
                                  ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                      key: 0,
                                      icon: "$home",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.indexlistOpenPoints = 0))
                                    }))
                                  : _createCommentVNode("", true),
                                (isHovering && _ctx.indexlistOpenPoints != 0)
                                  ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                      key: 1,
                                      icon: "$fa-chart-bar",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.vueGraph = true))
                                    }))
                                  : _createCommentVNode("", true),
                                (
                                        !_ctx.$vuetify.display.mobile &&
                                        isHovering &&
                                        _ctx.indexlistOpenPoints != 0
                                    )
                                  ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                      key: 2,
                                      icon: "$fa-search-plus",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.vueDetailed = true))
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_next, {
                                  class: "mx-1",
                                  onClick: _ctx.next
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "ma-2 mb-0 py-0"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" Statut des factures en cours ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "ma-2 mb-0 py-0 d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.subtitle), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "py-0"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.generalLedgerDetailsLoading)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              size: 70,
                              width: 7,
                              color: "primary",
                              indeterminate: "",
                              style: {"margin":"24px"}
                            }))
                          : (_ctx.chartData)
                            ? (_openBlock(), _createBlock(_component_bar_chart, {
                                key: 1,
                                data: _ctx.chartData,
                                options: _ctx.options,
                                height: _ctx.$vuetify.display.mobile ? 75 : 90
                              }, null, 8, ["data", "options", "height"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })),
            (_ctx.vueGraph)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 2,
                  "no-gutters": "",
                  class: "mt_auto d-flex align-end",
                  style: {"min-height":"3rem"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_icon, {
                          icon: "$fa-search-minus",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.vueGraph = false))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1040, ["elevation", "class", "style"])
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      minWidth: "1200px",
      modelValue: _ctx.vueDetailed,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vueDetailed) = $event)),
      title: _ctx.detailedDialogTitle
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccountableAccountBalanceDetailOpenPoints, {
          companyId: _ctx.companyId,
          accountingPeriodId: _ctx.accountingPeriodId,
          mode: "openPoints",
          notReconciliated: true,
          accountableAccountInfo: _ctx.accountableAccountInfo,
          inAccountingTransactions: _ctx.accountableAccountInfo.accountingTransactions,
          onBankTransactionSelected: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onBankTransactionSelected($event)))
        }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountInfo", "inAccountingTransactions"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}